define('baseline/search',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.matchTrack = exports.matchPlace = exports.matchLaser = void 0;
    function matchLaser(laser, query) {
        // Make a super string of all properties we want to search
        var sb = "";
        if (laser.name) {
            sb += laser.name;
        }
        if (laser.place) {
            sb += " " + placeString(laser.place);
        }
        return matchSuperstring(sb, query);
    }
    exports.matchLaser = matchLaser;
    /**
     * Return true if place matches query string, and should be shown in search results
     */
    function matchPlace(place, query) {
        // Make a super string of all properties we want to search
        var sb = placeString(place);
        return matchSuperstring(sb, query);
    }
    exports.matchPlace = matchPlace;
    /**
     * Return true if track matches query string, and should be shown in search results
     */
    function matchTrack(track, query) {
        // Make a super string of all properties we want to search
        var sb = "";
        if (track.place) {
            sb += placeString(track.place);
        }
        if (track.suit) {
            sb += " " + track.suit;
        }
        if (track.canopy) {
            sb += " " + track.canopy;
        }
        if (track.starred) {
            sb += " starred";
        }
        if (track.stats && track.stats.plan && track.stats.plan.name === "Wingsuit BASE") {
            sb += " Wingsuit BASE";
        }
        return matchSuperstring(sb, query);
    }
    exports.matchTrack = matchTrack;
    /**
     * Return true if item with superstring matches query string
     */
    function matchSuperstring(superstring, query) {
        var lower = normalize(superstring);
        // Break into tokens and require all
        for (var _i = 0, _a = normalize(query).split(" "); _i < _a.length; _i++) {
            var token = _a[_i];
            if (lower.indexOf(token) < 0) {
                return false;
            }
        }
        return true;
    }
    /**
     * Strip accents and make lowercase
     */
    function normalize(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    }
    /**
     * Turn a place into a superstring
     */
    function placeString(place) {
        var sb = place.name + " " + place.region + " " + place.country + " " + place.objectType;
        if (place.wingsuitable) {
            sb += " wingsuit";
        }
        if ("DZ" === place.objectType) {
            sb += " skydive";
        }
        if (place.objectType && "BASEO".indexOf(place.objectType) >= 0) {
            sb += " BASE";
        }
        return sb;
    }
});
//# sourceMappingURL=/assets/javascripts/baseline/search.js.map;
